import { useEffect, useRef, useState } from 'react';
import ModelComponent from './../components/ModelComponent';
import { get_room_recordings } from '../../Services/Service';
import styles from './components/ParticipantsModal/ParticipantsModal.module.css';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./modal.css";
import { Navigation, Pagination } from "swiper/modules";
import { NORECORDS } from '../../Services/CommonLibrary';
import { memo, useMemo } from 'react';

const RecordingModal = ({ session, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [openUser, setOpenUser] = useState([]);
  const [recordings, setRecordings] = useState([]);
  const videoRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(0); // ✅ track swiper index

  useEffect(() => {
    handleLoadRecordings();
  }, []);

  const handleLoadRecordings = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const response = await get_room_recordings(session.id);
      if (response.status == 200 && response.data.code == 200) {
        let _users = [];
        response.data.data.video_records.map((item) => {
          let key = item.goqii_livewoc_participant_id;
          let order = 4;
          if (item.type == "all") {
            key = "all";
            item.name = `all`;
            order = 1;
          }
          if (item.type == "host") {
            key = "host";
            item.name = `host`;
            order = 2;
          }
          if (item.type == "screen") {
            item.name = `Share Screen`;
            key = "share";
            order = 3;
          }
          let _newData = {
            name: item.name,
            users: [..._users?.[key]?.users ?? [], item],
            order: order,
          };
          _users[key] = _newData;

          if (key == "all") {
            setOpenUser((p) => _newData);
          }
          return item;
        });
        setRecordings((pr) => _users);
      } else {
        console.warn(response);
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      setLoading(false);
    }
  };

  const VideoSwiper = memo(
    ({
      button_id = 1,
      children,
      slidesPerView = 4,
      isShowButton = true,
      initialSlide = 0,
      onSlideChange,
    }) => {
      return (
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={10}
          slidesPerView={slidesPerView}
          navigation={{
            nextEl: `.custom-next_${button_id}`,
            prevEl: `.custom-prev_${button_id}`,
          }}
          pagination={{ clickable: true }}
          initialSlide={initialSlide} // ✅ keep last position
          onSlideChange={(swiper) => onSlideChange && onSlideChange(swiper.activeIndex)}
        >
          {children}
          {isShowButton && (
            <div
              className="d-flex justify-content-between mb-10"
              style={{
                position: "absolute",
                bottom: "-18px",
                width: "100%",
                zIndex: 9999,
              }}
            >
              <div
                className={`custom-btn custom-prev_${button_id}`}
                style={{
                  left: "10px",
                  cursor: "pointer",
                  zIndex: 99,
                  position: "absolute",
                }}
              >
                <i className="bi bi-caret-left-fill" />
              </div>
              <div
                className={`custom-btn custom-next_${button_id}`}
                style={{
                  right: "10px",
                  cursor: "pointer",
                  zIndex: 99,
                  position: "absolute",
                }}
              >
                <i className="bi bi-caret-right-fill" />
              </div>
            </div>
          )}
        </Swiper>
      );
    }
  );

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (video && i !== index) {
        video.pause();
      }
    });
  };

  const ParticipantsSwiper = ({ recordings, openUser, setOpenUser }) => {
    const participantSlides = useMemo(() => {
      return Object.keys(recordings)
        .sort((a, b) => recordings[a].order - recordings[b].order)
        .map((groupKey) => {
          const group = recordings[groupKey];
          return (
            <SwiperSlide
              key={`card_${groupKey}`}
              onClick={() => setOpenUser(group)}
            >
              <h5
                className={`card p-2 text-center truncate capitalize ${
                  group.name === openUser?.name ? "active_user" : ""
                }`}
                style={{
                  zIndex: -1,
                  marginBottom: "50px",
                  cursor: "pointer",
                }}
              >
                {group.name}
              </h5>
            </SwiperSlide>
          );
        });
    }, [recordings, openUser]);

    return (
      <div className="container my-3">
        <h5 className="mb-3">Participants</h5>
        <VideoSwiper
          isShowButton={Object.keys(recordings)?.length > 4}
          initialSlide={activeIndex} // ✅ restore slide
          onSlideChange={setActiveIndex} // ✅ update state when swiped
        >
          {participantSlides}
        </VideoSwiper>
      </div>
    );
  };

  return (
    <>
      <ModelComponent
        isOpen={true}
        onClose={() => onClose && onClose()}
        heading={`${session.sessionName}: Recordings`}
      >
        {loading ? (
          <div className={styles.loadingContainer}>
            <div className={styles.loadingSpinner}></div>
            <p>Loading participants... </p>
          </div>
        ) : Object.keys(recordings).length == 0 ? (
          <div className="mb-20">
            <NORECORDS marginTop="100px" message="No Recording Found" />
          </div>
        ) : (
          <>
            <div className='bg-black'>
              {openUser?.users?.map(({ video_url, id }, index) => (
                  <video
                      src={video_url}
                      ref={(el) => (videoRefs.current[index] = el)}
                      controls
                      width="250"
                      onPlay={() => handlePlay(index)}
                      style={{
                        height: "50vh",
                        marginBottom: "10px",
                      }}
                    />
                ))}
            </div>
            <ParticipantsSwiper
              openUser={openUser}
              recordings={recordings}
              setOpenUser={setOpenUser}
            />
          </>
        )}
      </ModelComponent>
    </>
  );
};

export default RecordingModal;
